// dev 전용 심사 로그인. 다른 환경에서는 404. refresh 없음.
import { authPublicApiClient } from "@/shared/api";

export type ReviewLoginResponse = { grantType: "Bearer"; accessToken: string };

export const reviewLogin = async (
  loginId: string,
  password: string,
): Promise<ReviewLoginResponse> => {
  const { data } = await authPublicApiClient.post<ReviewLoginResponse>(
    "/auth/review/login",
    { loginId, password },
  );
  return data;
};
